import getUberToken from './getUberToken';
import getAppState from './getAppState';

export default function getConfig(state) {
    const { config } = state;
    return config;
}

export function getGlobalConfig(state) {
    const { global = {} } = getConfig(state);

    return global;
}

export function getHeadConfig(state) {
    const { head = {} } = getConfig(state);

    return head;
}

export function getCommerceConfig(state) {
    const uberToken = getUberToken(state);
    const { global = {} } = getConfig(state);
    const { commerce = {} } = global.services;
    const { brandId } = global.application;
    const { country, language, locale, langISO, langId } = getAppState(state);
    return { uberToken, country, language, locale, brandId, langISO, langId, ...commerce };
}
